import ComboBox from './combobox.vue';
export default ComboBox;


// WEBPACK FOOTER //
// ./src/components/combobox/index.js